<template>
    <div class="container page">
        <van-nav-bar class="nav-bar" fixed placeholder>
            <template #left>
                <img :src="$store.getters.getBaseInfo.ico !== undefined
                    ? $store.getters.getBaseInfo.ico
                    : '/img/null.png'
                    " />
            </template>
            <template #right>
                <img @click="$router.push('/Mine')" class="w2" src="/img/home/shuju.png" alt="">
            </template>
        </van-nav-bar>
        <div class="title">{{ this.$t('guide') }}</div>
        <div class="content m-md2">
            <p>
                1. 텔레그램 다운로드→매니저 프로필 하단에 있는 매칭문의 클릭→안내원 텔레그램 자동으로 연결됩니다.

            </p>
            <p>2. 매칭 신청 시 다음 내용을 정확히 기재해 주시고,스케줄 오류 방지를 위해 시간/장소를 반드시 재확인해 주세요.</p>
            <br />
            <br />
            <img src="/img/guide.png" alt="">
        </div>
        <Footer :is_show="true"></Footer>
    </div>
</template>

<script>
import Footer from '@/common/Footer'

export default {
    data() {
        return {

        };
    },
    components: {
        Footer
    },
    methods: {
        back() {
            return window.history.back();
        }
    },
    created() {

    }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.less";

.title {
    padding: @pd1;
    color: @theme2;
    text-align: center;
    border-bottom: 1px solid @grey;
}

.content {
    color: @white;

    /deep/ img {
        width: 100%;
    }
}
</style>